import { render } from "./Header.vue?vue&type=template&id=e878606a&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=e878606a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e878606a"

export default script